import { type FC } from "react";

import { FormattedPrice } from "@jti/ui";

import styles from "./SummaryRow.module.scss";

type SummaryRowProps = {
  label: string;
  price: {
    value: number;
    currency: string;
  };
  isDiscount?: boolean;
};

export const SummaryRow: FC<SummaryRowProps> = ({ label, price, isDiscount }) => {
  const shouldEnsureNegative = isDiscount && price.value !== 0;
  const formattedValue = shouldEnsureNegative ? -Math.abs(price.value) : price.value;

  return (
    <div className={styles.listingLine}>
      <div className={styles.listingLineText}>{label}</div>
      <span className={styles.listingLinePrice}>
        <FormattedPrice value={formattedValue} currency={price.currency} />
      </span>
    </div>
  );
};
